document.addEventListener(
  'click',
  function (e) {
    const link = e.target.closest('.footer-block a[href="/cart"]');
    if (!link) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    document.querySelector('.cart-drawer-button')?.click();
  },
  true
);

document.addEventListener(
  'click',
  function (e) {
    const link = e.target.closest('.footer-block a[href="/wishlist"]');
    if (!link) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    document.querySelector('.xb-header__icon')?.click();
  },
  true
);

$(document).ready(function(){
    $(document).on("click",".openpopup", function(){
        $(".popup-click-price, .popup-content").addClass("active");
    });
    $(document).on("click",".closex", function(){
      $(".popup-click-price, .popup-content").removeClass("active");
    });

    document.addEventListener('click', function(e) {
      if (
        e.target.closest('.jdgm-prev-badge__stars') ||
        e.target.closest('.jdgm-preview-badge--with-link')
      ) {
        console.log('if call....');
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

      //   var $accordion = $('#judgeme_product_reviews').parents('.accordion-details');
      //   var $summary = $accordion.find('.accordion-details__summary');
      //   var isExpanded = $accordion.attr('aria-expanded') === 'true';

      //   if (!isExpanded) {
      //     $summary.trigger('click');
      //   }
      //   console.log(111);
      //   var headerHeight_top = $('.header__top').outerHeight(true) || 0;
      //   var headerHeight_main = $('.shopify-section-group-header-group').outerHeight(true) || 0;
      //   var headerHeight_bottom = $('.header__bottom').outerHeight(true) || 0;
      //   var targetOffset = $("#judgeme_product_reviews").offset().top - headerHeight_top - headerHeight_main - headerHeight_bottom;
      //   console.log(targetOffset);

      //   $('html, body').animate({
      //     scrollTop: targetOffset
      //   }, 600);
      }
    }, true);
});
